/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { User } from '../models/user';
@Injectable({
  providedIn: 'root',
})
class ManagementService extends __BaseService {
  static readonly ManagementGetUserByEmailPath = '/management/users';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `ManagementService.ManagementGetUserByEmailParams` containing the following parameters:
   *
   * - `email`:
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  ManagementGetUserByEmailResponse(params: ManagementService.ManagementGetUserByEmailParams): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.email != null) __params = __params.set('email', params.email.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/management/users`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param params The `ManagementService.ManagementGetUserByEmailParams` containing the following parameters:
   *
   * - `email`:
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  ManagementGetUserByEmail(params: ManagementService.ManagementGetUserByEmailParams): __Observable<User> {
    return this.ManagementGetUserByEmailResponse(params).pipe(
      __map(_r => _r.body as User)
    );
  }
}

namespace ManagementService {

  /**
   * Parameters for ManagementGetUserByEmail
   */
  export interface ManagementGetUserByEmailParams {
    email: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { ManagementService }